import SuccessorBorrowerAdd from './SuccessorBorrowerAdd';

export default SuccessorBorrowerAdd;
